// extracted by mini-css-extract-plugin
export default {"gameRewardCount":"RewardCount_gameRewardCount_yP10F"};